// extracted by mini-css-extract-plugin
export default {"fieldLabel":"form_fieldLabel__PcCUP"};